<template>
    <div class="login-modal-backdrop">
        <div class="login-modal-warp" id="id-need-up">
            <div class="login-modal-header">
                {{ $t("common.Login") }}
                <div
                    class="close-btn ico ico-btn-close"
                    @click="closeSelf()"
                ></div>
            </div>
            <div class="login-modal-body-warp">
                <div :style="'height:0.69rem'"></div>
                <UserName ref="account" @check-event="checkState()"></UserName>
                <div :style="'height:0.69rem'"></div>
                <Password ref="password" @check-event="checkState()"></Password>
                <div :style="'height:0.79rem'"></div>
                <div
                    :class="{
                        'login-modal-btn-red': isCanLogin,
                        'login-modal-btn-gray': !isCanLogin,
                    }"
                    @click="onLogin()"
                >
                    {{ $t("common.Login") }}
                </div>
                <div class="login-modal-facebook" @click="onFBLogin()">
                    {{ $t("common.Facebook") }}
                </div>
            </div>
            <div class="login-modal-register" @click="onRegister()">
                {{ $t("common.Registered") }}
            </div>
            <div class="login-modal-retrieve" @click="onRetrieve()">
                {{ $t("common.Retrieve_password") }}
            </div>
        </div>
    </div>
</template>
<script>
import UserName from "../common/input_user_name";
import Password from "../common/input_user_password";
import ServerManager from "../../interface/server";
import tools from "../../utils/fun";
import eventConfig from "../../baseConfig/eventConfig";
import AnalystManager from "../../utils/analyst";
export default {
    name: "login",
    components: {
        UserName,
        Password,
    },
    props: {},
    data() {
        return {
            isCanLogin: false,
        };
    },
    mounted() {
        tools.on(eventConfig.facebookResponse, (data) => {
            let uid = data.facebook_userId;
            let token = data.facebook_token;
            this.facebookLogin(uid, token);
        });
        if (this.$store.state.common.username) {
            this.$refs.account.$data.userName = this.$store.state.common.username;
        }
    },
    methods: {
        closeSelf() {
            tools.emit(eventConfig.playEffect, "pop");
            this.$emit("on-close");
        },
        OK() {
            this.$emit("on-ok");
        },
        onRetrieve() {
            this.$emit("on-retrieve");
        },
        onRegister() {
            this.$emit("on-register");
        },
        onFBLogin() {
            if (
                window.AndroidBridge &&
                window.AndroidBridge.loginWithFacebook
            ) {
                AnalystManager.updateActionStamp(eventConfig.google.login.FACEBOOK_LOGIN);
                AnalystManager.event(
                    this,
                    eventConfig.google.login.EVENT,
                    eventConfig.google.login.FACEBOOK_PRESS
                );
                window.AndroidBridge.loginWithFacebook();
            } else {
                tools.emit(
                    eventConfig.LOGIN_ERROR,
                    this.$t("components.login.app")
                );
            }
        },
        facebookLogin(uid, token) {
            tools.setLoadingState(true);
            AnalystManager.event(
                this,
                eventConfig.google.login.EVENT,
                eventConfig.google.login.FACEBOOK_RETURN
            );
            ServerManager.facebookLogin(
                this,
                uid,
                token,
                (res) => {
                    this.getUserAction();
                    AnalystManager.event(
                        this,
                        eventConfig.google.login.EVENT,
                        eventConfig.google.login.FACEBOOK_SUCCESS,
                        null,
                        AnalystManager.getActionStamp(eventConfig.google.login.FACEBOOK_LOGIN)
                    );
                    //af facebook注册上报
                    if (res.data.newRegiser) {
                        window.AndroidBridge && window.AndroidBridge.afCompleteRegistration && window.AndroidBridge.afCompleteRegistration("facebook");
                    } else {
                        //af 登录上报
                        window.AndroidBridge && window.AndroidBridge.afLogin && window.AndroidBridge.afLogin();
                    }
                },
                (err) => {
                    tools.setLoadingState(false);
                    tools.emit(eventConfig.LOGIN_ERROR, err);
                }
            );
        },
        checkState() {
            console.log("checkState");
            this.isCanLogin = false;
            this.$refs.password.checkPassword();
            this.$refs.account.checkAccount();
            this.$refs.password.checkError();
            if (
                !this.$refs.password.$data.isOk ||
                !this.$refs.account.$data.isOk
            ) {
                return;
            }
            this.isCanLogin = true;
        },
        onLogin() {
            console.log("onLogin");
            this.$refs.password.checkPassword();
            this.$refs.account.checkAccount();
            this.$refs.password.checkError();
            if (
                !this.$refs.password.$data.isOk ||
                !this.$refs.account.$data.isOk
            ) {
                return;
            }

            tools.setLoadingState(true);
            this.password = this.$refs.password.$data.password;
            this.userName = this.$refs.account.$data.userName;
            tools.setLoadingState(true);
            ServerManager.login(
                this,
                this.userName,
                this.password,
                "in",
                (data) => {
                    tools.setLoadingState(false);
                    console.log("login Data:", data);
                    this.getUserAction();
                    AnalystManager.event(
                        this,
                        eventConfig.google.login.EVENT,
                        eventConfig.google.login.LOGIN_SUCCESS,
                        null,
                        AnalystManager.getActionStamp(eventConfig.google.login.COMMON_LOGIN)
                    );
                    //af 登录上报
                    window.AndroidBridge && window.AndroidBridge.afLogin && window.AndroidBridge.afLogin();
                },
                (err) => {
                    tools.setLoadingState(false);
                    // tools.emit(eventConfig.LOGIN_ERROR, err);
                }
            );
            AnalystManager.updateActionStamp(eventConfig.google.login.COMMON_LOGIN);
        },
        getUserAction() {
            tools.setLoadingState(true);
            ServerManager.getUserInfo(
                this,
                (data) => {
                    tools.emit(eventConfig.LOGIN_SUC);
                    setTimeout(() => {
                        this.closeSelf();
                        tools.setLoadingState(false);
                        //login 时间刷新，避免用户刷新重复登录
                        if (
                            this.$route.query &&
                            this.$route.query["action"] == "login"
                        ) {
                            tools.toPage(
                                this,
                                { path: "/", query: { page: "login" } },
                                true
                            );
                        }
                    }, 300);
                },
                (error) => {
                    tools.setLoadingState(false);
                    tools.emit(eventConfig.LOGIN_ERROR, error);
                }
            );
        },
    },
    destroyed() {
        tools.off(eventConfig.facebookResponse);
    },
};
</script>

<style >
@import "../../assets/spritesmith-generated/home.css";
@import "../../assets/css/login.css";

.login-modal-register {
    position: absolute;
    right: 60px;
    top: 167px;

    font-size: 22px;
    font-family: Arial;
    font-weight: 400;
    text-decoration: underline;
    color: #ff8400;
}
.login-modal-retrieve {
    position: absolute;
    right: 27px;
    top: 322px;

    font-size: 22px;
    font-family: Arial;
    font-weight: 400;
    text-decoration: underline;
    color: #23f219;
}
.login-modal-facebook {
    margin-top: 24px;
    font-size: 30px;
    font-family: Arial;
    font-weight: 400;
    text-decoration: underline;
    color: #00b6ff;
}
</style>



// WEBPACK FOOTER //
// src/components/login/rummy_login.vue